import { GetUncheckedCampaignPositionsGroupedCheckTypeInline as CheckType } from '@/services/ws-operations/src/main/resources/rest-api';

import type { ParamsValidator } from 'src/components/RouteParamsValidator';
import type { ApprovalRouteParams, CampaignManagementRouteParams, QualityAssuranceRouteParams } from './types';
import { ApprovalStatus, DigitalOperationStatus } from './types';

const VALID_APPROVAL_STATUSES = Object.values(ApprovalStatus);
const VALID_DIGITAL_OPERATION_STATUSES = Object.values(DigitalOperationStatus).filter(
  (status) => status !== DigitalOperationStatus.PENDING_APPROVAL,
);
const VALID_CHECK_TYPES = Object.values(CheckType);

export const validateApprovalStatus: ParamsValidator<ApprovalRouteParams> = ({ status }) => VALID_APPROVAL_STATUSES.includes(status);

export const validateDigitalOperationStatus: ParamsValidator<CampaignManagementRouteParams> = ({ status }) =>
  // TODO: Fix this the next time the file is edited.
  // @ts-expect-error fix later
  VALID_DIGITAL_OPERATION_STATUSES.includes(status);

export const validateCheckTypes: ParamsValidator<QualityAssuranceRouteParams> = ({ checkType }) => VALID_CHECK_TYPES.includes(checkType);
